"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyAncestorBindingConstraintsWithName = isAnyAncestorBindingConstraintsWithName;
const isAnyAncestorBindingConstraints_1 = require("./isAnyAncestorBindingConstraints");
const isBindingConstraintsWithName_1 = require("./isBindingConstraintsWithName");
function isAnyAncestorBindingConstraintsWithName(name) {
    return (0, isAnyAncestorBindingConstraints_1.isAnyAncestorBindingConstraints)((0, isBindingConstraintsWithName_1.isBindingConstraintsWithName)(name));
}
//# sourceMappingURL=isAnyAncestorBindingConstraintsWithName.js.map